export const shouldShowFilters = (...filters: string[][]) =>
  // we check if > 1 as when length is 1 then there is no need to show filters
  // because either only 1 device or all devices have same properties
  filters.some(filter => filter.length > 1)
